import React, { useState } from "react";
import PropTypes from "prop-types";
import { FormGroup, Input, Label, Button, ModalFooter, Spinner } from "reactstrap";

const propTypes = {
  cancelOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      footnote: PropTypes.string
    })
  ).isRequired,
  isLoading: PropTypes.bool.isRequired,
  error: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  onKeep: PropTypes.func.isRequired
};

const CancelOptionsStep = ({ cancelOptions, isLoading, error = null, onSubmit, onKeep }) => {
  const singleOption = cancelOptions.length === 1;
  const [selected, setSelected] = useState(singleOption ? cancelOptions[0].value : "");

  return (
    <div>
      <p className="text-center text-muted mb-3">
        {singleOption
          ? "We are sorry to see you go."
          : "We are sorry to see you go. Please select the option below that works best for you."}
      </p>

      {error && (
        <div className="notifications danger mb-3">
          <div className="notifications__error-message">{error}</div>
        </div>
      )}

      {singleOption ? (
        <div className="text-center mb-3">
          <p className="mb-1">{cancelOptions[0].label}</p>
          {cancelOptions[0].footnote && (
            <small className="text-muted">{cancelOptions[0].footnote}</small>
          )}
        </div>
      ) : (
        <FormGroup>
          {cancelOptions.map(option => (
            <div key={option.value} className="mb-3 ml-4">
              <Label check className="d-flex align-items-start">
                <Input
                  type="radio"
                  name="cancel_option"
                  value={option.value}
                  checked={selected === option.value}
                  onChange={() => setSelected(option.value)}
                  className="mt-1 mr-2"
                />
                <span>
                  {option.label}
                  {option.footnote && (
                    <small className="d-block text-muted mt-1">{option.footnote}</small>
                  )}
                </span>
              </Label>
            </div>
          ))}
        </FormGroup>
      )}

      <ModalFooter className="pt-2 px-0">
        <Button color="secondary" className="btn-sharp" onClick={onKeep}>
          Back to my ad
        </Button>
        <Button
          color="primary"
          className="btn-sharp"
          onClick={() => onSubmit(selected)}
          disabled={!selected || isLoading}
        >
          {isLoading ? (
            <>
              <Spinner color="light" size="sm" /> Processing...
            </>
          ) : (
            "Continue"
          )}
        </Button>
      </ModalFooter>
    </div>
  );
};

CancelOptionsStep.propTypes = propTypes;

export default CancelOptionsStep;
